export default __webpack_public_path__ + "static/media/AwakenFox.77f9f923.png";